/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RetryPalAuthWithMissingInputRequest
 */
export interface RetryPalAuthWithMissingInputRequest {
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof RetryPalAuthWithMissingInputRequest
     */
    categories: Array<{ [key: string]: any; }>;
}

/**
 * Check if a given object implements the RetryPalAuthWithMissingInputRequest interface.
 */
export function instanceOfRetryPalAuthWithMissingInputRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "categories" in value;

    return isInstance;
}

export function RetryPalAuthWithMissingInputRequestFromJSON(json: any): RetryPalAuthWithMissingInputRequest {
    return RetryPalAuthWithMissingInputRequestFromJSONTyped(json, false);
}

export function RetryPalAuthWithMissingInputRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetryPalAuthWithMissingInputRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categories': json['categories'],
    };
}

export function RetryPalAuthWithMissingInputRequestToJSON(value?: RetryPalAuthWithMissingInputRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'categories': value.categories,
    };
}

